import { createElement } from 'react';
import styles from './screen-reader-only.module.less';

const ScreenReaderOnly = ({ className = '', tag = 'div', children, ...props }) =>
    createElement(tag, { ...props, className: [styles.screenReaderOnly, className].join(' ') }, children);

export default ScreenReaderOnly;
